import Vue from 'vue'

/** form */
import Block from "@/components/Block.vue";
import Icon from "@/components/Icons.vue";
import SelectWithAutocomplete from "@/components/SelectWithAutocomplete.vue";
import Grid from "@/components/Grid.vue";
import TableBlock from "@/components/Table.vue"
import Modal from "@/components/ModalDialog.vue"
import OnOffButton from "@/components/OnOffButton.vue"

const components = { Grid, Block, Icon, SelectWithAutocomplete, TableBlock, Modal, OnOffButton }

Object.entries(components).forEach(([name, component]) => {
    Vue.component(name, component)
})